import React, { FC, useState } from "react";
import { useInsuranceLabels } from "../../../../Utils/Context/labelsContext";
import { Button } from "../../../../Partials/Button";
import { DoctorsApi } from "../../../../../Api/DoctorsApi";
import { StreamLineIcon } from "../../../../../SvgIcon/StreamLineIcon";
import { InsuranceDoctorDto } from "@apiModels/Insurance/InsuranceDoctorDto.csharp";

const doctorApi = new DoctorsApi();

export const GeneralInfoHeader: FC<InsuranceDoctorDto> = (props) => {
  const { id, name, jobTitle, pictureUrl, isFavourite } = props;

  const { labels } = useInsuranceLabels();

  const [fav, setFav] = useState(isFavourite);

  const addToFavorite = async (id: string) => {
    if (isFavourite) {
      await doctorApi.deleteFavourite(id);
      setFav(false);
    } else {
      await doctorApi.addFavourite(id);
      setFav(true);
    }
  };

  return (
    <div className="generalInfoHeader">
      <div className="generalInfoHeader__imageContainer">
        <img
          className="generalInfoHeader__image"
          alt={name}
          src={`${pictureUrl}?width=144&height=144&rmode=crop&ranchor=top`}
        />
      </div>
      <div className="generalInfoHeader__info">
        <Button
          onClick={() => addToFavorite(id)}
          type="clear"
          size="small"
          tier="primary"
        >
          <span className="insuranceButton__label">
            <StreamLineIcon iconName={fav ? "s-star-filled" : "s-star"} />
            <span>
              {fav
                ? labels.removeFromFavouritesLabel
                : labels.addToFavouritesLabel}
            </span>
          </span>
        </Button>
        <h1 className="generalInfoHeader__header">{name}</h1>
        <span className="generalInfoHeader__subHeader">{jobTitle}</span>
      </div>
    </div>
  );
};
